import { NewsAttachment } from '@centecomm/portal-service';
import { DocumentLink } from '../../Types';

export const mapNewsAttachmentToDocumentLink = (newsId: number, { name }: NewsAttachment): DocumentLink => ({
    title: name,
    link: `${API_ROOT}/news/${newsId}/attachments/${name}`,
});
